import template from './bursaries_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class BursariesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class BursariesHelpPageClass
{
	constructor (bindings)
	{
		this.viewModel = new BursariesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

// Register the dialog
export default {
	name: 'BursariesHelp',
	dialog_class: BursariesHelpPageClass,
	template: template,
	template_filename: 'translation/dialogs/bursaries_help',
	provider: 'ps'
};
